"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerDialogPM = void 0;
const Entities_1 = require("../../Entities");
class SpinnerDialogPM {
    updateAlertObserver(alert) {
        if (alert === this.observingAlert)
            return;
        if (this.observingAlert !== null) {
            this.observingAlert.removeObserver(this.doUpdateView);
        }
        if (alert !== null) {
            alert.addObserver(this.doUpdateView);
        }
        this.observingAlert = alert;
    }
    vmHasChanged(vm) {
        var _a, _b;
        if (this.lastVM === undefined)
            return true;
        if (vm === null && this.lastVM === null)
            return false;
        if ((vm === null || vm === void 0 ? void 0 : vm.message) === ((_a = this.lastVM) === null || _a === void 0 ? void 0 : _a.message) &&
            (vm === null || vm === void 0 ? void 0 : vm.title) === ((_b = this.lastVM) === null || _b === void 0 ? void 0 : _b.title)) {
            return false;
        }
        return true;
    }
    constructor(repo, updateView) {
        this.repo = repo;
        this.updateView = updateView;
        this.observingAlert = null;
        this.doUpdateView = () => {
            let vm = null;
            if (this.repo.activeDialog &&
                this.repo.activeDialog.type === Entities_1.spinnerDialogType) {
                const spinnerDialog = this.repo.activeDialog;
                this.updateAlertObserver(spinnerDialog);
                vm = {
                    message: spinnerDialog.message,
                    title: spinnerDialog.title,
                };
            }
            else {
                this.updateAlertObserver(null);
            }
            if (!this.vmHasChanged(vm))
                return;
            this.updateView(vm);
            this.lastVM = vm;
        };
        this.dispose = () => {
            this.repo.removeObserver(this.doUpdateView);
            if (this.observingAlert) {
                this.observingAlert.removeObserver(this.doUpdateView);
            }
        };
        repo.addObserver(this.doUpdateView);
        this.doUpdateView();
    }
}
exports.SpinnerDialogPM = SpinnerDialogPM;
